import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Overview',
      type: 'details',
      content: {
        '{}': {
          fields: {
            if: [
              [
                {
                  '!=': [
                    {
                      '@': 'fieldsForCurrentRecord',
                    },
                    null,
                  ],
                },
                {
                  '@': 'fieldsForCurrentRecord',
                },
              ],
              {
                '[]': [
                  {
                    '{}': {
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Mission',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value:
                        'Give leaders the confidence to pursue their boldest visions and the clarity to pursue them wisely.',
                      readonly: true,
                    },
                  },
                  {
                    '{}': {
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Product Vision',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value:
                        "The leader's go-to source of business intelligence, delivering not just data, but the understanding that drives confident decision-making.",
                      readonly: true,
                    },
                  },
                ],
              },
            ],
          },
          columnCount: 1,
        },
      },
    },
  },
  subqueries: {
    fieldsForCurrentRecord: {
      target: 'dim::!outcomes',
      quantity: 1,
      filter: {
        and: [
          {
            '=': [{ '@_': 'id' }, { '@$': 'currentEntityId' }],
          },
          {
            '=': [{ '@.': '!id' }, { '@$': 'currentRecordId' }],
          },
        ],
      },
      selection: {
        '[]': [
          {
            '{}': {
              meta: {
                '{}': {
                  direct: {
                    '{}': {
                      name: 'Description',
                      type: 'TEXT',
                    },
                  },
                },
              },
              value: { '@.': '!descr' },
              readonly: true,
            },
          },
          {
            '{}': {
              meta: {
                '{}': {
                  direct: {
                    '{}': {
                      name: 'Accountable',
                      type: 'LIST',
                    },
                  },
                },
              },
              value: { '@': 'accountable' },
              readonly: true,
            },
          },
          {
            '{}': {
              meta: {
                '{}': {
                  direct: {
                    '{}': {
                      name: 'Responsible',
                      type: 'LIST',
                    },
                  },
                },
              },
              value: { '@': 'responsible' },
              readonly: true,
            },
          },
          {
            '{}': {
              meta: {
                '{}': {
                  direct: {
                    '{}': {
                      name: 'Consulted',
                      type: 'LIST',
                    },
                  },
                },
              },
              value: { '@': 'consulted' },
              readonly: true,
            },
          },
          {
            '{}': {
              meta: {
                '{}': {
                  direct: {
                    '{}': {
                      name: 'Informed',
                      type: 'LIST',
                    },
                  },
                },
              },
              value: { '@': 'informed' },
              readonly: true,
            },
          },
        ],
      },
      subqueries: {
        assignees: {
          target: 'ent:!outcome_assignees:!assignee',
          ref: {
            attr: 'attr:ent#!outcome_assignees#!assignee:!outcome',
          },
          selection: {
            '{}': {
              isAccountable: { '@.': '!is_accountable' },
              isResponsible: { '@.': '!is_responsible' },
              isConsulted: { '@.': '!is_consulted' },
              isInformed: { '@.': '!is_informed' },
            },
          },
        },
        accountable: {
          using: 'assignees',
          target: 'ent:!people:!person',
          ref: {
            attr: 'attr:ent#!outcome_assignees#!assignee:!person',
          },
          filter: {
            some: [
              { '@': 'assignees' },
              { '@>': [{ '@$': '$value' }, 'isAccountable'] },
            ],
          },
          selection: {
            '@.': '!name',
          },
          sort: {
            by: { '@.': '!name' },
          },
        },
        responsible: {
          using: 'assignees',
          target: 'ent:!people:!person',
          ref: {
            attr: 'attr:ent#!outcome_assignees#!assignee:!person',
          },
          filter: {
            some: [
              { '@': 'assignees' },
              { '@>': [{ '@$': '$value' }, 'isResponsible'] },
            ],
          },
          selection: {
            '@.': '!name',
          },
          sort: {
            by: { '@.': '!name' },
          },
        },
        consulted: {
          using: 'assignees',
          target: 'ent:!people:!person',
          ref: {
            attr: 'attr:ent#!outcome_assignees#!assignee:!person',
          },
          filter: {
            some: [
              { '@': 'assignees' },
              { '@>': [{ '@$': '$value' }, 'isConsulted'] },
            ],
          },
          selection: {
            '@.': '!name',
          },
          sort: {
            by: { '@.': '!name' },
          },
        },
        informed: {
          using: 'assignees',
          target: 'ent:!people:!person',
          ref: {
            attr: 'attr:ent#!outcome_assignees#!assignee:!person',
          },
          filter: {
            some: [
              { '@': 'assignees' },
              { '@>': [{ '@$': '$value' }, 'isInformed'] },
            ],
          },
          selection: {
            '@.': '!name',
          },
          sort: {
            by: { '@.': '!name' },
          },
        },
      },
    },
  },
}
